import { styled, dialogClasses, Box, Dialog, Alert } from '@mui/material';

import CapabilitiesInfo from '~components/CapabilitiesInfo';

export const AssistantGenerateRoutesDialogContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    maxWidth: 1000,
    width: '100%',
    minHeight: 'calc(100% - 64px)',
  },
});

export const AssistantGenerateRoutesDialogLoadingContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  flex: 1,
});

export const AssistantGenerateRoutesDialogCapabilitiesInfo = styled(
  CapabilitiesInfo,
)(({ theme, columns }) => ({
  marginRight: theme.spacing(2),
  minWidth: 90,
  gridTemplateColumns: `repeat(${columns}, auto)`,
}));

export const AssistantGenerateRoutesDialogInfoAlert = styled(
  ({ text, className }: { text: string; className?: string }) => (
    <Alert
      severity="info"
      variant="standard"
      icon={false}
      className={className}
    >
      {text}
    </Alert>
  ),
)(({ theme }) => ({
  border: `1px solid ${theme.palette.info.light}`,
  fontSize: 13,
  padding: theme.spacing(0, 2),
}));
